var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "config-page" }, [
    _c(
      "div",
      { staticClass: "page-header" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary" },
            on: {
              click: function ($event) {
                return _vm.saveDraft(0)
              },
            },
          },
          [_vm._v("保存")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary" },
            on: {
              click: function ($event) {
                return _vm.saveDraft(1)
              },
            },
          },
          [_vm._v("发布")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.goBack } },
          [_vm._v("返回管理页面")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "page-content" }, [
      _c(
        "div",
        { staticClass: "page-left" },
        [_c("leftConfigPage", { attrs: { pointer: _vm.pointer } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "phone" }, [
        _c("div", { staticClass: "deviceMockup" }, [
          _c(
            "section",
            {
              ref: "imageTofile",
              staticClass: "phoneAll",
              attrs: { id: "imageTofile" },
            },
            [
              _c("img", {
                staticClass: "statusBar",
                attrs: {
                  src: require("../../../../static/phoneTop.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("headTop", {
                attrs: { pageSetup: _vm.pageSetup },
                nativeOn: {
                  click: function ($event) {
                    return _vm.headTop($event)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "phone-container",
                  style: {
                    "background-color": _vm.pageSetup.backgroundColor,
                    backgroundImage:
                      "url(" + _vm.resPath + _vm.pageSetup.backgroundImg + ")",
                  },
                  on: {
                    drop: function ($event) {
                      return _vm.drop($event)
                    },
                    dragover: function ($event) {
                      return _vm.allowDrop($event)
                    },
                    dragleave: function ($event) {
                      return _vm.dragleaves($event)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { class: _vm.pointer.show ? "pointer-events" : "" },
                    _vm._l(_vm.pageComponents, function (item, index) {
                      return _c(
                        item.component,
                        {
                          key: index,
                          tag: "component",
                          staticClass: "componentsClass",
                          style: {
                            border:
                              item.active && _vm.deleShow
                                ? "2px solid #155bd4"
                                : "",
                          },
                          attrs: {
                            datas: item.setStyle,
                            "data-type": item.type,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.activeComponent(item, index)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.deleShow,
                                  expression: "deleShow",
                                },
                              ],
                              staticClass: "deles",
                              attrs: { slot: "deles" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteObj(index)
                                },
                              },
                              slot: "deles",
                            },
                            [
                              _c("span", {
                                staticClass: "iconfont icon-sanjiaoxingzuo",
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.text) +
                                  "\n                    "
                              ),
                              _c("i", { staticClass: "el-icon-delete-solid" }),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("phoneBottom"),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "decorateAll" },
        [
          _c("div", { staticClass: "decorateTab" }, [
            _c(
              "span",
              {
                class: _vm.rightcom === "decorate" ? "active" : "",
                on: {
                  click: function ($event) {
                    _vm.rightcom = "decorate"
                  },
                },
              },
              [_vm._v("\n            页面设置\n          ")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: _vm.rightcom === "componenmanagement" ? "active" : "",
                on: {
                  click: function ($event) {
                    _vm.rightcom = "componenmanagement"
                  },
                },
              },
              [_vm._v("\n            组件管理\n          ")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class:
                  _vm.rightcom != "decorate" &&
                  _vm.rightcom != "componenmanagement"
                    ? "active"
                    : "",
                on: {
                  click: function ($event) {
                    _vm.rightcom = ""
                  },
                },
              },
              [_vm._v("\n            组件设置\n          ")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "decorateAnima" } },
            [
              _c(_vm.rightcom, {
                key: _vm.panelKey,
                tag: "component",
                attrs: {
                  datas: _vm.currentproperties,
                  title: _vm.title,
                  pages: _vm.pageComponents,
                },
                on: { componenmanagement: _vm.componenmanagement },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }